import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import ShowEntityData from '../Elements/ShowEntityData';
import FreelancerUserItem from './FreelancerUserItem';
import FreelancerUserService from '../Services/FreelancerUserService';
import moneyHelper from '../Helpers/moneyHelper';
import FaIcon from '../Elements/FaIcon';
import ShowPayableAssignmentComponent from '../Elements/ShowPayableAssignmentComponent';
import ShowFreelancerLineItemsComponent from '../Elements/ShowFreelancerLineItemsComponent';
import FreelancerUserAdmin from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin';
import Link from '../Elements/link';
import FpaAdmin from '../Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaAdmin';
import FreelancerLineItemAdmin from '../Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemAdmin';
import FreelancerInvoiceService from '../Services/FreelancerInvoiceService';
import FreelancerInvoiceStatusEnum from '../Enums/FreelancerInvoiceStatusEnum';
import CaspianImage from '../Elements/CaspianImage';
import LogComponent from '../Elements/LogComponent';
import FreelancerPaymentExportAdmin from '../Contents/FreelancerInvoicing/FreelancerPaymentExport/FreelancerPaymentExportAdmin';
import FreelancerPaymentExportSearchParams from '../Contents/FreelancerInvoicing/FreelancerPaymentExport/FreelancerPaymentExportSearchParams';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FeeTypesEnum from '../Enums/FeeTypesEnum';
import FreelancerFeeHelper from '../Helpers/ModelHelpers/FreelancerFeeHelper';

export default class FreelancerInvoiceItem {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerInvoiceId = '';
      this.FreelancerUserId = '';
      this.Type = '';
      this.Status = '';
      this.Filename = '';
      this.TotalAmount = '';
      this.CurrencyId = '';
      this.CreatedByFreelancerUser = '';
      this.CreatedByBareUser = '';
      this.CreatedOn = '';
      this.FinalizedByBareUser = '';
      this.FinalizedOn = '';
      this.ApprovedByBareUser = '';
      this.ApprovedOn = '';
      this.UploadedByBareUser = '';
      this.UploadedOn = '';
      this.Yrmo = '';
      this.FreelancerUserName = '';
      this.CreatedByBareUserName = '';
      this.FinalizedByBareUserName = '';
      this.CurrencyCode = '';
      this.FreelancerUserOfficeName = '';
      this.NumberOfAttachedAssignments = '';
      this.NumberOfAttachedLineItems = '';
      this.FreelancerPaymentExportId = '';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.FreelancerInvoiceId = item.freelancerInvoiceId;
    this.FreelancerUserId = item.freelancerUserId;
    this.Type = item.type;
    this.Status = item.status;
    this.Filename = item.filename;
    this.TotalAmount = item.totalAmount;
    this.CurrencyId = item.currencyId;
    this.CreatedByFreelancerUser = item.createdByFreelancerUser;
    this.CreatedByBareUser = item.createdByBareUser;
    this.CreatedOn = item.createdOn;
    this.FinalizedByBareUser = item.finalizedByBareUser;
    this.FinalizedOn = item.finalizedOn;
    this.ApprovedByBareUser = item.approvedByBareUser;
    this.ApprovedOn = item.approvedOn;
    this.UploadedByBareUser = item.uploadedByBareUser;
    this.UploadedOn = item.uploadedOn;
    this.Yrmo = item.yrmo;
    this.FreelancerUserName = item.freelancerUserName;
    this.CreatedByBareUserName = item.createdByBareUserName;
    this.FinalizedByBareUserName = item.finalizedByBareUserName;
    this.CurrencyCode = item.currencyCode;
    this.FreelancerUserOfficeName = item.freelancerUserOfficeName;
    this.NumberOfAttachedAssignments = item.numberOfAttachedAssignments;
    this.NumberOfAttachedLineItems = item.numberOfAttachedLineItems;
    this.FreelancerPaymentExportId = item.freelancerPaymentExportId;
    this.PaymentCurrencyId = item.paymentCurrencyId;
    this.ExchangeRate = item.exchangeRate?.toFixed(4);
    this.PaymentCurrencyCode = item.paymentCurrencyCode;

    this.Selected = false;
  }

  static NameOfTheIdField() {
    return 'FreelancerInvoiceId';
  }
  static nameOfTheItemDetailList() {
    return 'Vendor Invoices';
  }

  static MoneyFields = ['TotalAmount'];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['CreatedOn', 'FinalizedOn'];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        {
          name: FreelancerInvoiceItem.getAssignmentsCellTextContent,
          label: 'Assigments Linked',
          className: 'text-left',
        },
        { name: 'CreatedByBareUserName', label: 'Created By', className: 'text-left' },
        { name: 'CreatedOn', label: 'Created On', className: 'text-center' },

        { name: FreelancerInvoiceItem.getLineItemsTextContent, label: 'Line Items Linked', className: 'text-left' },
        { name: 'FinalizedByBareUserName', label: 'Finalized by', className: 'text-left' },
        { name: 'FinalizedOn', label: 'Finalized On', className: 'text-center' },

        { name: FreelancerInvoiceItem.getInvoiceTypeText, label: 'Invoice Type', className: 'text-left' },
        { name: 'UploadedByBareUser', label: 'Uploaded By' },
        { name: 'UploadedOn', label: 'Uploaded On' },

        { name: 'Status', label: 'Status', className: 'text-left' },
        { name: 'ApprovedByBareUser', label: 'Approved By' },
        { name: 'ApprovedOn', label: 'Approved On' },

        {
          name: (item) => moneyHelper.toMoneyFormat(item.TotalAmount, item.CurrencyCode),
          label: 'Total Amount',
          width: TabListTableCellWidthEnum.Full,
          className: 'h4 text-center',
        },
        { name: 'ExchangeRate', label: 'Payment Exchange Rate' },
        { name: 'PaymentCurrencyCode', label: 'Payment Currency' },
      ],
    },
    {
      tabName: 'FreelancerUser',
      tabLabel: 'Vendor',
      icon: 'fa-solid fa-swimmer',
      data: [
        {
          name: FreelancerInvoiceItem.getFreelancerUserContent,
          label: 'Vendor',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-solid fa-socks',
      data: [
        {
          name: FreelancerInvoiceItem.getPayableAssignmentsContent,
          label: 'Payable Assignments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Line Items',
      tabLabel: 'Line Items',
      icon: 'fa-solid fa-paperclip',
      data: [
        { name: FreelancerInvoiceItem.getLineItemContent, label: 'Line Items', width: TabListTableCellWidthEnum.Table },
      ],
    },
    {
      tabName: 'Invoice Image',
      tabLabel: 'Invoice Image',
      icon: 'fa-solid fa-eye',
      data: [
        {
          name: FreelancerInvoiceItem.getInvoiceImageContent,
          label: 'Invoice Image',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    // {tabName:"Comments", tabLabel:"Comments", icon:"fa-solid fa-comment",  data:[
    // 	{name:FreelancerLineItem.getCommentsContent, label:"Comments",width: TabListTableCellWidthEnum.TwoLines},
    // ]},
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: FreelancerInvoiceItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  // static getCommentsContent(item)
  // {
  // 	return (
  // 		<Comments
  // 			entityTypeId={10007}
  //     		entityId={item.FreelancerLineItemId}
  // 		/>
  // 	);
  // }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='FreelancerInvoice'
        entityId={item.FreelancerInvoiceId}
      />
    );
  }

  static getFreelancerUserContent(item) {
    return (
      <ShowEntityData
        itemId={item.FreelancerUserId}
        entityName='Vendor'
        type={FreelancerUserItem}
        serviceGetByIdFunction={FreelancerUserService.GetFreelancerUserById}
      />
    );
  }

  static getPayableAssignmentsContent(item) {
    return <ShowPayableAssignmentComponent freelancerInvoiceId={item.FreelancerInvoiceId} />;
  }

  static getLineItemContent(item) {
    return <ShowFreelancerLineItemsComponent freelancerInvoiceId={item.FreelancerInvoiceId} />;
  }

  static getInvoiceImageContent(item) {
    return (
      <div className='text-center'>
        {item.Status === FreelancerInvoiceStatusEnum.Created ||
        item.Status === FreelancerInvoiceStatusEnum.Finalized ||
        item.Status === FreelancerInvoiceStatusEnum.InvoiceDismissed ? (
          <div className='text-center'>-</div>
        ) : (
          <CaspianImage
            src={() => FreelancerInvoiceService.GetInvoiceImageFile(item.FreelancerInvoiceId)} //it has to be a service promise
            className='pointer'
            alt={'Invoice'}
            style={{
              maxWidth: '40vw',
              maxHeight: '20vh',
            }}
            fileName={item.Filename}
          />
        )}
      </div>
    );
  }

  static clickOnInvoiceImage(item) {
    alert('clickOnInvoiceImage');
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: FreelancerInvoiceItem.getSelectedCellHeader,
        orderById: '',
        data: FreelancerInvoiceItem.getSelectedCellContent,
        minWidth: 20,
      },
      {
        label: 'Id',
        orderById: 'FreelancerInvoiceId',
        data: 'FreelancerInvoiceId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 30,
      },
      {
        label: 'Vendor (ID)',
        orderById: 'FreelancerUserName',
        data: FreelancerInvoiceItem.getFreelancerNameCellContent,
      },
      { label: 'Revenue Period', orderById: 'Yrmo', data: 'Yrmo' },
      {
        label: 'Total Amount',
        orderById: 'TotalAmount',
        data: (item) => moneyHelper.toMoneyFormat(item.TotalAmount, item.CurrencyCode),
      },
      { label: 'Office', orderById: 'FreelancerUserOfficeName', data: 'FreelancerUserOfficeName' },
      { label: 'Info', orderById: 'Info', data: FreelancerInvoiceItem.getInfoCellContent },
      {
        label: 'Actions',
        orderById: '',
        data: FreelancerInvoiceItem.getActionsContent.bind(this),
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static clickOnGlobalSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={FreelancerInvoiceItem.selectedStatus()}
          onChange={(e) => {
            FreelancerInvoiceItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getPaymentExportSearchItem(item) {
    let paymentSearchItem = null;
    if (item.FreelancerPaymentExportId) {
      paymentSearchItem = new FreelancerPaymentExportSearchParams();
      paymentSearchItem.FreelancerPaymentExportId = item.FreelancerPaymentExportId.toString();
    }
    return paymentSearchItem;
  }

  static getInfoCellContent(item) {
    return (
      <span>
        {FreelancerInvoiceItem.getTypeIcon(item.Type)} {FreelancerInvoiceItem.getStatusIcon(item.Status)}
      </span>
    );
  }

  static getTypeIcon(key) {
    let tooltipText = '';
    switch (key) {
      case 'RM':
        tooltipText = 'Resource';
        break;
      case 'DQ':
        tooltipText = 'Data Quality';
        break;
      default:
        tooltipText = key;
        break;
    }

    return (
      <FaIcon
        iconName={FreelancerFeeHelper.GetFeeTypeIcon(key)}
        className='infoButton'
        tooltipText={tooltipText}
      />
    );
  }

  static getStatusIcon(key) {
    let iconName = '';
    switch (key) {
      case FreelancerInvoiceStatusEnum.Created:
        iconName = 'fa-regular fa-wand-magic';
        break;
      case FreelancerInvoiceStatusEnum.FileUploaded:
        iconName = 'fa-solid fa-file-upload';
        break;
      case FreelancerInvoiceStatusEnum.Finalized:
        iconName = 'fa-regular fa-door-closed';
        break;
      case FreelancerInvoiceStatusEnum.InvoiceApproved:
        iconName = 'fa-regular fa-stamp';
        break;
      case FreelancerInvoiceStatusEnum.InvoiceDismissed:
        iconName = 'fa-regular fa-ban';
        break;
      case FreelancerInvoiceStatusEnum.Exported:
      case FreelancerInvoiceStatusEnum.LinkedToExport:
        iconName = 'fa-solid fa-envelope-open-dollar';
        break;
      case FreelancerInvoiceStatusEnum.ToBeSentToTipalti:
        iconName = 'fa-solid fa-envelope-open-dollar';
        break;
      case FreelancerInvoiceStatusEnum.SentToTipalti:
        iconName = 'fa-regular fa-money-check-alt';
        break;
      case FreelancerInvoiceStatusEnum.DeletedAtTipalti:
        iconName = 'fa-solid fa-trash-can';
        break;
      case FreelancerInvoiceStatusEnum.ErrorAtTipalti:
        iconName = 'fa-solid fa-exclamation-triangle';
        break;
      case FreelancerInvoiceStatusEnum.Paid:
        iconName = 'fa-solid fa-file-invoice-dollar';
        break;
      default:
        break;
    }

    return (
      <FaIcon
        iconName={iconName}
        className='infoButton'
        tooltipText={key}
      />
    );
  }

  static getAssignmentsCellTextContent(item) {
    if (item.NumberOfAttachedAssignments !== 0)
      return <span className='fa-solid fa-socks'> {item.NumberOfAttachedAssignments}</span>;
  }

  static getInvoiceTypeText(item) {
    if (item.Type === FeeTypesEnum.RM) return <span className='fa-regular fa-user-clock'> Resource</span>;

    if (item.Type === FeeTypesEnum.DQ) return <span className='fa-solid fa-clipboard-check'> Data Quality</span>;
  }

  static getLineItemsTextContent(item) {
    if (item.FreelancerInvoiceId !== 0)
      return <span className='fa-solid fa-paperclip'> {item.NumberOfAttachedLineItems}</span>;
  }

  static getFreelancerNameCellContent(item) {
    return (
      <Link
        linktext={`${item.FreelancerUserName} (${item.FreelancerUserId})`}
        title='Vendors'
        link={<FreelancerUserAdmin freelancerUserId={item.FreelancerUserId} />}
        className='link'
        iconName='fa-solid fa-person-swimming'
        url={`freelancer/search?FreelanceUserId=${item.FreelancerUserId}&OfficeName=`}
      />
    );
  }

  static clickOnSelect(item, selected) {
    alert('Empty function');
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          FreelancerInvoiceItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-trash-can',
            onClick: () => FreelancerInvoiceItem.clickOnDeleteIcon(item),
            text: 'Delete Invoice',
            disabled: item.Status !== FreelancerInvoiceStatusEnum.Created,
            roleKey: 'freelancerdatatable_action',
          },
          {
            iconName: 'fa-solid fa-upload',
            onClick: () => FreelancerInvoiceItem.clickOnUploadInvoiceImageIcon(item),
            text: 'Upload Invoice Image',
            disabled:
              item.Status !== FreelancerInvoiceStatusEnum.Finalized &&
              item.Status !== FreelancerInvoiceStatusEnum.InvoiceDismissed,
          },
          {
            iconName: 'fa-solid fa-eye',
            onClick: () => FreelancerInvoiceItem.clickOnApproveInvoiceImageIcon(item),
            text: 'Approve Invoice Image',
            disabled: item.Status !== FreelancerInvoiceStatusEnum.FileUploaded,
          },
          {
            iconName: 'fa-solid fa-file-excel',
            onClick: () => FreelancerInvoiceItem.clickOnDownloadInXLSIcon(item),
            text: 'Download Invoice Details in XLS',
          },
          {
            link: <FpaAdmin freelancerInvoiceId={item.FreelancerInvoiceId} />,
            iconName: 'fa-solid fa-socks',
            text: `Payable Assignments (#${item.NumberOfAttachedAssignments})`,
            disabled: item.NumberOfAttachedAssignments === 0,
            tooltipText: `Number Of Attached Assignments: ${item.NumberOfAttachedAssignments}`,
          },
          {
            link: <FreelancerLineItemAdmin freelancerInvoiceId={item.FreelancerInvoiceId} />,
            iconName: 'fa-solid fa-paperclip',
            tooltipText: `Number Of Attached Line Items: ${item.NumberOfAttachedLineItems}`,
            disabled: item.NumberOfAttachedLineItems === 0,
            text: 'Line Items',
          },
          {
            link: <FreelancerPaymentExportAdmin searchItem={this.getPaymentExportSearchItem(item)} />,
            iconName: 'fa-solid fa-file-export',
            tooltipText: item.FreelancerPaymentExportId ? `Payment Export: ${item.FreelancerPaymentExportId}` : '',
            disabled: !item.FreelancerPaymentExportId,
            text: 'Payment Exports',
            roleKey: 'freelancer_paymentexports',
          },
        ]}
      />
    );
  }

  static clickOnDeleteIcon(item) {
    alert('clickOnDeleteIcon');
  }

  static clickOnApproveInvoiceImageIcon(item) {
    alert('clickOnApproveInvoiceImageIcon');
  }

  static clickOnDownloadInXLSIcon(item) {
    alert('clickOnApproveInvoiceImageIcon');
  }

  static clickOnUploadInvoiceImageIcon(item) {
    alert('clickOnUploadInvoiceImageIcon');
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
